import React from 'react';
import { Button } from '../shared/Button';
import { ArrowRight, Check } from 'lucide-react';
export function VSLClose() {
  return <section id="book" className="w-full bg-[#0a0a0a] py-24 px-4 sm:px-6 lg:px-8 relative overflow-hidden" data-id="element-2450">
      {/* Background effects */}
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-[#3ab795]/10 via-[#0a0a0a] to-[#0a0a0a]" data-id="element-2451" />

      <div className="max-w-4xl mx-auto relative z-10 text-center" data-id="element-2452">
        <h2 className="text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-2453">
          If You’re Serious About Scaling, <br data-id="element-2454" />
          <span className="text-[#3ab795]" data-id="element-2455">This Is For You.</span>
        </h2>

        <div className="bg-[#121212] border border-white/10 rounded-2xl p-8 md:p-10 mb-12 max-w-2xl mx-auto text-left" data-id="element-2456">
          <h3 className="text-white font-bold text-xl mb-6 border-b border-white/10 pb-4" data-id="element-2457">
            Who this is for:
          </h3>
          <ul className="space-y-3 mb-8" data-id="element-2458">
            {['Investors who understand volume creates leverage', 'Wholesalers tired of cold calling burnout', 'Flippers who need consistent deal flow', 'Creative finance buyers looking for sub-to deals'].map((item, i) => <li key={i} className="flex items-start gap-3 text-[#b8bcc8]" data-id="element-2459">
                <div className="mt-1 bg-[#3ab795]/20 p-1 rounded-full" data-id="element-2460">
                  <Check className="w-3 h-3 text-[#3ab795]" data-id="element-2461" />
                </div>
                <span data-id="element-2462">{item}</span>
              </li>)}
          </ul>

          <div className="bg-red-500/5 border border-red-500/20 rounded-lg p-4" data-id="element-2463">
            <p className="text-red-400 text-sm font-medium" data-id="element-2464">
              <span className="font-bold uppercase mr-2" data-id="element-2465">Not for:</span>
              Agents, tire kickers, or people scared of making offers.
            </p>
          </div>
        </div>

        <div className="flex flex-col items-center gap-4" data-id="element-2466">
          <Button variant="primary" size="lg" className="text-xl px-12 py-6 shadow-[0_0_40px_rgba(58,183,149,0.4)] hover:shadow-[0_0_60px_rgba(58,183,149,0.6)] scale-105" href="https://calendly.com/acquireflow/strategy" data-id="element-2467">
            Book Your Strategy Call
            <ArrowRight className="w-6 h-6 ml-2" data-id="element-2468" />
          </Button>
          <p className="text-[#6b7280] text-sm mt-2" data-id="element-2469">
            We’ll map out how this would look in your market.
          </p>
        </div>

        <div className="mt-20 text-[#b8bcc8]/40 text-sm" data-id="element-2470">
          © {new Date().getFullYear()} AcquireFlow. All rights reserved.
        </div>
      </div>
    </section>;
}